// @ts-expect-error
import { PostMessageTransportBackend, Transport } from '@jitsi/js-utils/transport';
import { APP_WILL_MOUNT, APP_WILL_UNMOUNT } from '../base/app/actionTypes';
import { CONFERENCE_JOINED, CONFERENCE_LEFT } from '../base/conference/actionTypes';
import { PARTICIPANT_LEFT } from '../base/participants/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { SET_RECEIVER_TRANSPORT } from './actionTypes';
import { clearRequest, disconnectAgent, discoverAgent, setReceiverTransport, setRemoteControlActive, stopController, stopReceiver } from './actions';
import { REMOTE_CONTROL_MESSAGE_NAME } from './constants';
import { onRemoteControlAPIEvent } from './functions';
import './subscriber';
/**
 * The redux middleware for the remote control feature.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case APP_WILL_MOUNT: {
            const { dispatch } = store;
            // A host application, such as an Electron shell, talks to the page
            // over postMessage. This stays in place until — and unless — a local
            // control agent answers, which is what happens in an ordinary browser.
            dispatch(setReceiverTransport(new Transport({
                backend: new PostMessageTransportBackend({
                    postisOptions: { scope: 'jitsi-remote-control' }
                })
            })));
            break;
        }
        case APP_WILL_UNMOUNT: {
            const { getState, dispatch } = store;
            const { transport } = getState()['features/remote-control'].receiver;
            if (transport) {
                transport.dispose();
                dispatch(setReceiverTransport());
            }
            dispatch(disconnectAgent());
            break;
        }
        case SET_RECEIVER_TRANSPORT: {
            const result = next(action);
            // Listening here rather than at CONFERENCE_JOINED is what lets the
            // transport be swapped for the local agent's once it is found: the
            // listener follows the transport instead of being attached to
            // whichever one happened to exist at the time.
            action.transport?.on('event', (event) => {
                if (event.name === REMOTE_CONTROL_MESSAGE_NAME) {
                    onRemoteControlAPIEvent(event, store);
                    return true;
                }
                return false;
            });
            return result;
        }
        case CONFERENCE_JOINED: {
            const result = next(action);
            // Silent: nobody is asked for anything, and the only thing this
            // decides is whether this participant can be asked for control at all.
            store.dispatch(discoverAgent());
            return result;
        }
        case CONFERENCE_LEFT: {
            const result = next(action);
            store.dispatch(disconnectAgent());
            return result;
        }
        case PARTICIPANT_LEFT: {
            const { getState, dispatch } = store;
            const state = getState();
            const { id } = action.participant;
            const { receiver, controller } = state['features/remote-control'];
            const { requestedParticipant, controlled } = controller;
            if (id === controlled) {
                dispatch(stopController());
            }
            if (id === requestedParticipant) {
                dispatch(clearRequest());
                dispatch(setRemoteControlActive(false));
            }
            if (receiver?.controller === id) {
                dispatch(stopReceiver(false, true));
            }
            break;
        }
    }
    return next(action);
});
